import { ChangeDetectionStrategy, Component, ElementRef, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Subject, combineLatest, distinctUntilChanged, map, startWith, takeUntil } from 'rxjs';
import { PdfViewerService } from '../../pdf-viewer.service';
import { PdfDocumentViewportsContainerService } from './pdf-document-viewports-container.service';

@Component({
  selector: 'ss-pdf-document-viewports-container',
  templateUrl: './pdf-document-viewports-container.component.html',
  styleUrls: ['./pdf-document-viewports-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PdfDocumentViewportsContainerComponent implements OnInit {

  private readonly _destroy = new Subject<void>();

  @ViewChildren('scrollable', { read: ElementRef })
  virtualScrollableElementQL!: QueryList<ElementRef<HTMLDivElement>>;

  readonly pdfDocumentsSubject = this._pdfViewerService.pdfDocumentInputsSubject;
  readonly viewportHeightSubject = this._pdfDocumentViewportsContainerService.viewportHeightSubject;
  readonly viewportResetSubject = this._pdfDocumentViewportsContainerService.viewportResetSubject;
  readonly addedPageContentSubject = this._pdfViewerService.addedPageContentSubject;
  readonly scrollTopSubject = this._pdfViewerService.scrollTopSubject;
  readonly pageOverlayStyleSubject = this._pdfDocumentViewportsContainerService.pageOverlayStyleSubject;
  readonly showVirtualScrollingElementObs = combineLatest([
    this.viewportResetSubject,
    this.pdfDocumentsSubject
  ])
    .pipe(

      map(([viewportReset, pdfDocuments]) => {
        return Boolean(!viewportReset && pdfDocuments)
      }),
      distinctUntilChanged(),
      startWith(false)
    )

  get pdfDocumentViewportsContainerService() {
    return this._pdfDocumentViewportsContainerService
  }
  constructor(
    readonly _pdfDocumentViewportsContainerService: PdfDocumentViewportsContainerService,
    private _pdfViewerService: PdfViewerService
  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit() {


    this.virtualScrollableElementQL
      .changes
      .pipe(
        takeUntil(this._destroy),
        startWith(this.virtualScrollableElementQL),
        map((virtualScrollableQL: QueryList<ElementRef<HTMLDivElement>>) => virtualScrollableQL.first?.nativeElement)
      )
      .subscribe((virtualScrollable) => {
        this._pdfViewerService.scrollerSubject.next(virtualScrollable);
      })

  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }
}
